import React, { ReactNode } from 'react';

export default function ModalPage({ children }: { children?: ReactNode | ReactNode[] }) {
    return <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>{children}</div>;
}
